import { Injector } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';

export class BaseNode implements TreeNode {
  label?: string;
  data?: any;
  icon?: string;
  children?: TreeNode[];
  leaf?: boolean;
  expandedIcon?: string;
  collapsedIcon?: string;
  selectable?: boolean;
  styleClass?: string;
  parent?: TreeNode;
  partialSelected?: boolean;
  expanded?: boolean;
  type?: string;
  key?: string;
  checked: boolean = true;
  num: string = '';
  //US-328923
  //RQ3: Implement of a dropdown to change the search size.
  // Control the page size.
  selectedPageSize: number = 50;
  // Control the starting point for data retrieval.
  offSet: number = 0;

  // Adding custom properties and methods
  labelTemplate: string = 'BaseNode';
  labelNodeName: string = 'BaseNode';
  ioc?: Injector;

  constructor(injector: Injector|undefined, data: any, labelTemplate: string) {
    this.ioc = injector;
    this.key = uuidv4();
    this.labelTemplate = labelTemplate;
    this.label = this.labelTemplate ?? 'BaseNode';
    this.expanded = false;
    this.data = data ? data : null;
    this.children = [];
    this.refreshLabel();
  }

  cloneNode(newParent: BaseNode): BaseNode|undefined {
    return new BaseNode(newParent.ioc!, {}, this.label!); // unused
  }

  refreshLabel(lazy:boolean=true) {}

}
